import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@vlabs/api';
import { NotificationProvider } from '@vlabs/monokit/entities/notifications';
import { WhiteLabelBrand } from '@vlabs/monokit/shared/ui/white-label-brand';
import { ResetPasswordPage, LoginPage } from '@vlabs/pages/auth';
import PropTypes from 'prop-types';
import 'i18next';
import { connect } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { selectIsAuthenticated } from '@vlabs/pages/auth/selectors';

import ScrollToTop from '@vlapps/point/src/components/scroll-to-top/ScrollToTop';

import st from './App.module.sass';
import { PointNavbar } from './navigation';
import { PointRouter } from './router';

function App({
  isAuthenticated = false,
}) {
  return (
    <BrowserRouter>
      <div className={st.App}>
        <ScrollToTop />
        {!isAuthenticated && (
          <Switch>
            <Route
              component={ResetPasswordPage}
              path="/auth/reset/:token"
            />
            <Route
              path="*"
              render={(props) => (
                <LoginPage
                  {...props}
                  CustomBrand={<WhiteLabelBrand style={{ backgroundPosition: 'center' }} />}
                />
              )}
            />
          </Switch>
        )}
        {!!isAuthenticated && (
          <React.Fragment>
            <PointNavbar />
            <QueryClientProvider client={queryClient}>
              <NotificationProvider>
                <PointRouter />
              </NotificationProvider>
            </QueryClientProvider>
          </React.Fragment>
        )}
      </div>
    </BrowserRouter>
  );
}

App.propTypes = {
  isAuthenticated: PropTypes.bool,
};

export default connect((state) => ({
  isAuthenticated: selectIsAuthenticated(state),
}))(App);
